import { Button, Divider, Typography } from '@mui/material';
import React from 'react';
import MainLayout from '../layout/MainLayout';
import { TransactionTable } from './TransactionTable';
import CurrencyExchangeIcon from '@mui/icons-material/CurrencyExchange';
import Color from '../layout/color/Color';

export const TransactionList = (props) => {
    return (
        <MainLayout>
            <Button endIcon={<CurrencyExchangeIcon sx={{color: Color.Main}}/>} sx={{ textAlign: 'left', ml: 1, cursor: 'default' }} size="medium">
                <Typography variant="h3">
                    Transaction Management
                </Typography>
            </Button>
            <Divider sx={{ width: '100%', mb: 6 }} />
            <TransactionTable />
        </MainLayout>
    )
}